
import { mapState, mapMutations } from 'vuex';
import BlogCategories from '@/components/blogCategories.vue';
import LoadMore from '@/components/ui/loadMore.vue';
import Intermission from '@/components/intermission';
import BlogPost from '@/components/blogPost';

export default {
  name: 'BlogCategory',

  components: {
    BlogCategories,
    LoadMore,
    Intermission,
    BlogPost,
  },

  async fetch() {
    try {
      await this.getPosts();
    } catch (_) {
      return this.$nuxt.error({ statusCode: 404 });
    }
  },

  data() {
    return {
      page: 1,
      lastPage: null,
      perPage: 6,
      loading: false,
    };
  },

  computed: {
    ...mapState(['posts', 'blogCategories']),

    ...mapState({
      info: (state) => state.options.field_blog_start,
    }),

    title() {
      return this.category ? this.category.name : this.info.title;
    },

    description() {
      return this.category ? this.category.description : this.info.description;
    },

    slug() {
      return this.$route.params.slug;
    },

    filteredPosts() {
      return this.category
        ? this.posts.filter((p) => p.categories.includes(this.category.id))
        : this.posts;
    },

    category() {
      return this.blogCategories && this.slug
        ? this.blogCategories.find((c) => c.slug === this.slug)
        : null;
    },

    postsIntermission() {
      const array = [...this.filteredPosts];
      for (let i = this.perPage; i < array.length + 1; i += 1 + this.perPage) {
        array.splice(i, 0, { id: `inter${i}` });
      }
      return array;
    },
  },

  methods: {
    ...mapMutations(['setPosts']),

    async getPosts() {
      this.loading = true;
      const { data, headers } = await this.$wp.posts({
        perPage: this.perPage,
        page: this.page,
        categories: this.category ? this.category.id : null,
      });
      this.loading = false;
      if (data.length) {
        this.setPosts(data);
        this.page++;
        if (headers['x-wp-totalpages']) {
          this.lastPage = parseInt(headers['x-wp-totalpages']);
        }
      }
    },
  },

  head() {
    return this.category
      ? this.$seo.yoast(this.category.yoast_head_json)
      : this.$seo.page('blog', this.$route.path);
  },
};
